import React from 'react';
import { AppShell } from './components/layout/AppShell';
import { GraphCanvas } from './components/graph/GraphCanvas';
import { ControlPanel } from './components/panels/ControlPanel';
import { DetailPanel } from './components/panels/DetailPanel';

function App() {
  return (
    <AppShell>
      <div className="absolute inset-0 bg-background">
        <GraphCanvas />
      </div>
      <ControlPanel />
      <DetailPanel />
    </AppShell>
  );
}

export default App;
